module.exports = new __parcel__URL__("blue_hoody.0e68e5bc.jpg").toString();